import type { Variation } from '@shared/types/types';
import type { VariationLoader } from '@tilelist/application/ports/VariationLoader.ts';

interface InspirationTilesState {
    comboId: null | string;
    isLoading: boolean;
    error: null | string;
    tiles: Variation[];
}

const initialState = (): InspirationTilesState => ({
    comboId: null,
    isLoading: true,
    error: null,
    tiles: [],
});

export const inspirationTilesState: InspirationTilesState = $state(initialState());

export async function fetchTiles(loader: VariationLoader | null, variationIds: string[], comboId: string) {
    if (!loader) return;
    if (inspirationTilesState.comboId === comboId && !inspirationTilesState.error) return;

    inspirationTilesState.comboId = comboId;
    inspirationTilesState.isLoading = true;
    inspirationTilesState.error = null;
    inspirationTilesState.tiles = [];

    try {
        const tiles: Variation[] = await loader.loadVariations(variationIds);

        if (inspirationTilesState.comboId !== comboId) return;
        inspirationTilesState.tiles = tiles;
        inspirationTilesState.isLoading = false;
    } catch {
        if (inspirationTilesState.comboId !== comboId) return;

        inspirationTilesState.comboId = null;
        inspirationTilesState.error = 'Variations konnten nicht geladen werden';
        inspirationTilesState.isLoading = false;
    }
}
